export default __webpack_public_path__ + "img/error-401.135d3968.svg";